import type { Task, TaskExecution } from "../features/task";
import API, { responseOf } from "./base";

export const share = (taskExecutionId: string): Promise<TaskExecution> =>
  responseOf(API.post(`/task-executions/${taskExecutionId}/share`));

export const unshare = (taskExecutionId: string): Promise<TaskExecution> =>
  responseOf(API.delete(`/task-executions/${taskExecutionId}/share`));

export const listSharedByProcessExecutionId = (
  processExecutionId: string,
): Promise<TaskExecution[]> =>
  responseOf(
    API.get(
      `/task-executions/byProcessExecutionId/${processExecutionId}/share`,
    ),
  );

export const getShared = (taskExecutionId: string): Promise<TaskExecution> =>
  responseOf(API.get(`/task-executions/${taskExecutionId}/share`));

export const getSharedTask = (taskExecutionId: string): Promise<Task> =>
  responseOf(API.get(`/task-executions/${taskExecutionId}/share/task`));

export const remindTaskAccount = (taskExecutionId: string): Promise<boolean> =>
  responseOf(API.post(`/task-executions/${taskExecutionId}/remind`));

export const assignMemberToProcessRole = (
  taskExecutionId: string,
  userId: string,
): Promise<boolean> =>
  responseOf(
    API.post(
      `/task-executions/${taskExecutionId}/assignMemberToProcessRole/${userId}`,
    ),
  );
